<template>
  <v-card>
    <v-toolbar flat color="white">
      <v-toolbar-title>Datasource configurations</v-toolbar-title>
    </v-toolbar>
    <DatasourcesEditDialog
      :dialog="dialog"
      :item="editedItem"
      :error="editError"
      :success="editSuccess"
      :disableSubmit="disableSubmit"
      :loading="editLoading"
      :typeOrbc="typeOrbc"
      @close="close"
      @save="save"
    />
    <v-data-table
      :headers="headers"
      :items="data"
      :loading="loading"
      item-key="id"
    >
      <template v-slot:item.edit="{ item }">
        <v-btn
          v-if="item.apiEntryPoint"
          @click="edit(item)"
          class="mr-2"
          elevation="0"
          icon
        >
          <v-icon small> edit </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { postling } from '../hooks';
import DatasourcesEditDialog from './DatasourcesEditDialog';

export default {
  components: {
    DatasourcesEditDialog,
  },
  data() {
    return {
      dialog: false,
      editLoading: false,
      editError: false,
      editSuccess: false,
      editedItem: {
        username: '',
        password: '',
        token: '',
      },
      defaultItem: {
        username: '',
        password: '',
        token: '',
      },
    };
  },
  props: {
    data: { type: Array },
    loading: { type: Boolean },
    client: { type: String },
    resourceType: { type: String },
    wrongDatasource: { type: Boolean },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Client',
          sortable: true,
          value: 'client',
        },
        {
          text: 'Datasource',
          sortable: true,
          value: 'datasource',
        },
        {
          text: 'Email',
          sortable: true,
          value: 'email',
        },
        {
          text: 'Api entry point',
          sortable: true,
          value: 'apiEntryPoint',
        },
        {
          text: 'Storage path',
          sortable: true,
          value: 'storagePath',
        },
        {
          text: 'Edit authorisation',
          value: 'edit',
          sortable: false,
          align: 'center',
        },
      ];
    },
    disableSubmit() {
      return !this.validateForm();
    },
  },
  methods: {
    edit(item) {
      this.editedItem = {
        ...this.defaultItem,
        ...item,
      };
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.editError = false;
      this.editSuccess = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
      });
    },
    async save() {
      if (this.validateForm()) {
        this.editLoading = true;
        this.editError = false;
        await postling('set-data-tubes-config', this.editedItem)
          .then(() => {
            this.editLoading = false;
            this.editSuccess = true;
            this.delayedClose();
          })
          .catch(() => {
            this.editLoading = false;
            this.editError = true;
          });
      }
    },
    typeOrbc() {
      return this.editedItem.type === 'datasourcesConfigorbc';
    },
    typeSbs() {
      return this.editedItem.type === 'datasourcesConfigsbs';
    },
    validateForm() {
      if (
        this.typeOrbc() &&
        this.editedItem.username &&
        this.editedItem.password
      ) {
        return true;
      }

      if (this.typeSbs() && this.editedItem.token) {
        return true;
      }

      return false;
    },
    delayedClose() {
      setTimeout(() => {
        this.dialog = false;
        this.editSuccess = false;
      }, 1200);
    },
  },
};
</script>
